import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <Section className="bg-cream-100" data-id="element-268" data-mp="3fznujnjr7f2f">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-deep" data-id="element-269" data-mp="3fym5ug9teu28">
        Usuarios que ya dominan su iPhone
      </p>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-270" data-mp="3ayhx5cf5f3mk">
        <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-ink-950 sm:text-4xl" data-id="element-271" data-mp="370ag0ggrw0au">
          Lo que dicen quienes ya lo aplicaron
        </h2>
        <p className="flex items-center gap-2 text-sm text-ink-950/60" data-id="element-272" data-mp="2x1ur8k57x34i">
          <StarIcon className="h-4 w-4 fill-current text-gold" aria-hidden="true" data-id="element-273" data-mp="2s1ymgiop57nw" />
          <span className="font-bold text-ink-950" data-id="element-274" data-mp="v9gavpibo6q7">4,9/5</span> · valoración de
          la comunidad
        </p>
      </div>

      <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-275" data-mp="q9tvb9f0uee8">
        {testimonials.map((item, index) => <li key={item.name} className={`flex h-full flex-col rounded-3xl border border-ink-950/10 bg-white p-6 ${index === 0 ? 'md:col-span-2' : ''}`} data-id="element-276" data-mp="h5f0hpouu32s" data-mpi={index}>
            <p className={`leading-relaxed text-ink-900 ${index === 0 ? 'text-lg sm:text-xl' : 'text-sm'}`} data-id="element-277" data-mp="m6chw021it38">
              “{item.quote}”
            </p>
            <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-278" data-mp="c622q9wg3blf">
              {item.photo ? <img src={item.photo} alt={`Foto de ${item.name}`} className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-279" data-mp="zwpq83iug9t3" /> : <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent/10 text-xs font-bold text-accent-deep" data-id="element-280" data-mp="14w296d6lgwqe">
                  {item.initials}
                </span>}
              <span className="text-xs font-semibold text-ink-950/55" data-id="element-281" data-mp="v4xwjk4e5nyq">
                {item.name} · {item.role}
              </span>
            </div>
          </li>)}
      </ul>
    </Section>;
}